import React from 'react';
import { Box, List, ListItem, ListItemText, ListItemSecondaryAction, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useUnits } from '../../../../utils/context/units/UnitsContext';

const UnitList = () => {
  const {units, removeUnit, fetchUnits } = useUnits();

  const handleRefresh = async () => {
    fetchUnits();
  };

  const handleDelete = (unit) => {
    removeUnit(unit);
  };

  return (
    <Box>
      {/* Refresh Button */}

      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <IconButton aria-label="refresh" onClick={handleRefresh}>
          <RefreshIcon />
        </IconButton>
      </Box>

      <List>
        {units.map((unit) => (
          <ListItem key={unit.id}>
            <ListItemText primary={unit.unitName} />

            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="delete" onClick={() => handleDelete(unit)}>
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default UnitList;
